"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectFilters = exports.selectDeviceType = void 0;
var _ramda = require("ramda");
const selectFilters = state => state.filters;
exports.selectFilters = selectFilters;
const selectDeviceType = state => (0, _ramda.path)(['page', 'deviceType'], state);
exports.selectDeviceType = selectDeviceType;